import { createSlice, PayloadAction, createAsyncThunk, Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { IQuickNotification, IQuickNotificationButton, QuickNotificationTypes } from './QuickNotification';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';

interface INotificationsState {
    quickNotification: IQuickNotification,
    globalLoaderStatus: boolean,
}

const initialState: INotificationsState = {
    quickNotification: {
        shown: false,
        message: "",
        type: "info"
    },
    globalLoaderStatus: false
}

const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        updateQuickNotification: (state: INotificationsState, action: PayloadAction<IQuickNotification>) => {
            state.quickNotification = action.payload
        },
        updateShownStatusQuickNotification: (state: INotificationsState, action: PayloadAction<{ status: boolean }>) => {
            state.quickNotification.shown = action.payload.status
        },
        updateGlobalLoaderStatus: (state: INotificationsState, action: PayloadAction<{ status: boolean }>) => {
            state.globalLoaderStatus = action.payload.status
        },
    }
})

/**
 * Use return quick notification
 */
export const useReturnQuickNotification = () => useSelector((state: RootState) => state.notifications.quickNotification)

/**
 * Use return global loader status
 */
export const useReturnGlobalLoaderStatus = () => useSelector((state: RootState) => state.notifications.globalLoaderStatus)

/**
 * Update quick notification
 */
export const updateQuickNotificationDetails = (
    shown: boolean, 
    message: string, 
    type: QuickNotificationTypes, 
    dispatch: Dispatch<UnknownAction>, 
    handleBeforeClose?: () => void, 
    autoHideDuration?: number,
    disableAautoHideDuration?: boolean, 
    customActionButtons?: Array<IQuickNotificationButton>
) => dispatch(updateQuickNotification({
    shown,
    message,
    type,
    handleBeforeClose,
    autoHideDuration,
    disableAautoHideDuration,
    customActionButtons
}))

export const { updateQuickNotification, updateShownStatusQuickNotification, updateGlobalLoaderStatus } = notificationsSlice.actions
export default notificationsSlice.reducer